import angular from 'angular';
import Popup from '../../../../../common/services/popup';
import PaymentPay from './payment-pay/payment-pay';
import payModalTemplateUrl from './payment-popup.ngtemplate.html';
class PaymentPopup extends Popup {
    constructor($rootScope, $modal) {
        super();
        this.$rootScope = $rootScope;
        this.$modal = $modal;
        this.templateUrl = '';
        this.contentTemplateUrl = payModalTemplateUrl;
    }
    open(data) {
        super.open(data);
    }
}
export default angular
    .module('doxy.common.services.paymentPopup', [PaymentPay])
    .service('paymentPopup', PaymentPopup).name;
